import {
    ITEMS_HEADER_LAYOUT_GRID,
    ITEMS_HEADER_LAYOUT_LIST,
    ITEMS_HEADER_LAYOUT_TABLE,
    ITEMS_VIEW_COMMAND_ACTION_COPY_URL,
    ITEMS_VIEW_COMMAND_ACTION_DELETE,
    ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD,
    ITEMS_VIEW_COMMAND_ACTION_EDIT,
    ITEMS_VIEW_COMMAND_ACTION_FAVORITE,
    ITEMS_VIEW_COMMAND_ACTION_MORE,
    ITEMS_VIEW_COMMAND_ACTION_NAVIGATE,
    ITEMS_VIEW_COMMAND_ACTION_PREVIEW,
    ITEMS_VIEW_COMMAND_ACTION_VIEW
} from './ui_component_constants';
import {LayoutViewType} from '../models/LayoutViewType';
import {SortType} from '../models/SortType';
import {SortOrder} from '../models/SortOrder';
import {getEmptySearchFilterPredefined} from '../utils/DtoUtils';

//DownloadCenter - Search Parameters
export const defaultDownloadCenterSearchParameterSortType = SortType.AZ.toString();
export const defaultDownloadCenterSearchParameterSortOrder = SortOrder.ASC.toString();
export const defaultDownloadCenterSearchParameterPageSize = 3;
export const defaultDownloadCenterSearchParameterRecentlyAdded = 0;
export const defaultDownloadCenterSearchPageSizeOptions = [defaultDownloadCenterSearchParameterPageSize.toString()];

//ItemsHeader
export const defaultItemsHeaderLayouts = [ITEMS_HEADER_LAYOUT_GRID, ITEMS_HEADER_LAYOUT_LIST, ITEMS_HEADER_LAYOUT_TABLE];
export const defaultItemsHeaderLayout = LayoutViewType.GRID.toString();
export const defaultItemsHeaderMobileLayouts = [ITEMS_HEADER_LAYOUT_GRID, ITEMS_HEADER_LAYOUT_LIST, ITEMS_HEADER_LAYOUT_TABLE];
export const defaultItemsHeaderMobileLayout = LayoutViewType.GRID.toString();

//ItemsView - Command Actions - In Row Menu
export const defaultItemsViewMaxItemsInRowGrid = 5;
export const defaultItemsViewMaxItemsInRowList = 5;
export const defaultItemsViewMaxItemsInRowTable = 5;
export const defaultItemsViewMobileMaxItemsInRowGrid = 5;
export const defaultItemsViewMobileMaxItemsInRowList = 5;
export const defaultItemsViewMobileMaxItemsInRowTable = 5;
export const defaultItemsViewItemsInRowGrid = [ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE];
export const defaultItemsViewItemsInRowList = [ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE];
export const defaultItemsViewItemsInRowTable = [ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE, ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD];
export const defaultItemsViewMobileItemsInRowGrid = [ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE];
export const defaultItemsViewItemsMobileInRowList = [ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE];
export const defaultItemsViewItemsMobileInRowTable = [ITEMS_VIEW_COMMAND_ACTION_DELETE, ITEMS_VIEW_COMMAND_ACTION_EDIT, ITEMS_VIEW_COMMAND_ACTION_FAVORITE, ITEMS_VIEW_COMMAND_ACTION_VIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL, ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_MORE, ITEMS_VIEW_COMMAND_ACTION_DOWNLOAD];
export const defaultItemsViewItemsInMoreGrid = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];
export const defaultItemsViewItemsInMoreList = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];
export const defaultItemsViewItemsInMoreTable = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];
export const defaultItemsViewMobileItemsInMoreGrid = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];
export const defaultItemsViewMobileItemsInMoreList = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];
export const defaultItemsViewMobileItemsInMoreTable = [ITEMS_VIEW_COMMAND_ACTION_PREVIEW, ITEMS_VIEW_COMMAND_ACTION_COPY_URL];

//ItemsView - Event Actions
export const defaultItemsViewFolderOnClickCommandAction = ITEMS_VIEW_COMMAND_ACTION_NAVIGATE;
export const defaultItemsViewFileOnClickCommandAction = ITEMS_VIEW_COMMAND_ACTION_VIEW;
export const defaultItemsViewMobileFolderOnClickCommandAction = ITEMS_VIEW_COMMAND_ACTION_NAVIGATE;
export const defaultItemsViewMobileFileOnClickCommandAction = ITEMS_VIEW_COMMAND_ACTION_VIEW;

//PageIndicator
export const defaultPageIndicatorMinVisibleItems = 7;
export const defaultPageIndicatorMobileMinVisibleItems = 4;

//Custom Filters
export const defaultMainFilters = [] as string[];
export const defaultSubFilters = [] as string[];
export const defaultPredefinedFilters = getEmptySearchFilterPredefined();
